
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDvVVkyot0EdT7DlLXnAdFYflPd_rY5_ls",
  authDomain: "calculator-61aa0.firebaseapp.com",
  projectId: "calculator-61aa0",
  storageBucket: "calculator-61aa0.firebasestorage.app",
  messagingSenderId: "71390652725",
  appId: "1:71390652725:web:8452bd847eaad1229b847c",
  measurementId: "G-V5BE81NDB4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);


// Initialize Firestore and export it
const db = getFirestore(app);

// Make sure to export the db variable
export { db };